import axios from '@/plugins/axios.js'

export function save(params) {
    return axios.post("payable/save", params);
}

export function remove(id) {
    return axios.delete("payable/" + id);
}

export function update(params) {
    return axios.post("payable/update", params);
}

export function list(params) {
    return axios.get("payable/list", { params: params });
}

export function detail(id) {
    return axios.get("payable/" + id);
}

export function savePayableItem(params) {
    return axios.post("payable/item/save", params);
}

export function removePayableItem(id) {
    return axios.delete("payable/item/" + id);
}

export function updatePayableItem(params) {
    return axios.post("payable/item/update", params);
}

export function listPayableItem(params) {
    return axios.get("payable/item/list", { params: params });
}